import { Avatar } from '@app/components'

export const PHONE_VERIFICATION_LIST = [
  {
    icon: <Avatar icon={null} />,
    title: 'Get link by email',
    description: 'We’ll email you at john@example.com',
  },
  {
    icon: <Avatar icon={null} />,
    title: 'Scan a QR code',
    description: 'Use your phone camera or a QR code scanner',
  },
]
